import { useState } from "react";
import UploadFileModal from "./FileUploadModal";
import { MdOutlineCloudUpload } from "react-icons/md";

const UploadFileButton = () => {
  const [isFileUploadModalOpen, setIsFileUploadModalOpen] = useState(false);
  const showModal = () => {
    setIsFileUploadModalOpen(true);
  };

  return (
    <div>
      <button
        className="flex items-center justify-center mb-2 bg-blue-500 p-2 w-full rounded text-white font-medium hover:bg-blue-600/90 active:bg-blue-600"
        onClick={showModal}
      >
        <span className="pr-2 text-xl">
          <MdOutlineCloudUpload />
        </span>
        <span>Upload File</span>
      </button>
      <UploadFileModal
        isFileUploadModalOpen={isFileUploadModalOpen}
        setIsFileUploadModalOpen={setIsFileUploadModalOpen}
      />
    </div>
  );
};

export default UploadFileButton;
